import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    borderRadius: "12px !important",
    overflow: "hidden",
    minWidth: "420px",
  },
  dialogHeader: {
    backgroundColor: "#1a1a1a",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "18px 24px",
  },
  dialogHeaderTitle: {
    fontSize: "16px !important",
    fontWeight: "700 !important",
    color: "#ffffff",
    fontFamily: "'Inter', sans-serif !important",
  },
  closeIconBtn: {
    color: "#ffffff !important",
    padding: "4px !important",
  },
  dialogBody: {
    padding: "28px 24px",
    backgroundColor: "#ffffff",
  },
  avatarWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "16px",
  },
  avatarImg: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid #f1f5f9",
  },
  nameText: {
    fontSize: "18px !important",
    fontWeight: "700 !important",
    color: "#0f172a",
    fontFamily: "'Inter', sans-serif !important",
  },
  descriptionText: {
    fontSize: "14px !important",
    color: "#64748b",
    fontFamily: "'Inter', sans-serif !important",
    marginTop: "6px !important",
  },
  dialogFooter: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "16px 24px",
    borderTop: "1px solid #f1f5f9",
    backgroundColor: "#ffffff",
  },
  cancelButton: {
    backgroundColor: "#ffffff !important",
    color: "#374151 !important",
    borderRadius: "8px !important",
    padding: "10px 24px !important",
    textTransform: "none !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    border: "1px solid #e5e7eb !important",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "#f9fafb !important",
    },
  },
  deleteButton: {
    backgroundColor: "#ef4444 !important",
    color: "#ffffff !important",
    borderRadius: "8px !important",
    padding: "10px 24px !important",
    textTransform: "none !important",
    fontWeight: "600 !important",
    fontFamily: "'Inter', sans-serif !important",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "#dc2626 !important",
    },
  },
}));

export default useStyles;
